import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMissingInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#cf3a65",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99999 14.5C11.5899 14.5 14.5 11.5899 14.5 8.00001C14.5 4.41015 11.5899 1.5 7.99999 1.5C4.41015 1.5 1.5 4.41015 1.5 8.00001C1.5 11.5899 4.41015 14.5 7.99999 14.5Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.32849 6.22924C6.32804 5.92232 6.41439 5.62153 6.57757 5.36158C6.74075 5.10163 6.9741 4.89312 7.25072 4.76012C7.52733 4.62711 7.83591 4.57504 8.14084 4.6099C8.44578 4.64476 8.73462 4.76514 8.97406 4.95714C9.21354 5.14914 9.39381 5.40494 9.4941 5.69501C9.59438 5.98508 9.61065 6.2976 9.5409 6.5965C9.47119 6.89541 9.31838 7.1685 9.10011 7.38426C8.88184 7.60005 8.60701 7.7497 8.30732 7.81594C8.20903 7.83533 8.12037 7.88794 8.05622 7.96494C7.99211 8.04197 7.95641 8.13866 7.95511 8.23886V8.72164",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.95597 11.2812C7.89607 11.2812 7.84753 11.2326 7.84753 11.1727C7.84753 11.1129 7.89607 11.0643 7.95597 11.0643",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.9563 11.2812C8.0162 11.2812 8.06474 11.2326 8.06474 11.1727C8.06474 11.1129 8.0162 11.0643 7.9563 11.0643",
			stroke: "currentColor"
		})
	]
});
export default SvgMissingInfo;
